import ApiClient from './ApiClient';

class LinkedinApi extends ApiClient {
  constructor() {
    super('linkedin', { accountScoped: true });
  }

  authLink(params) {
    return window.axios.post(`${this.url}/connection/auth_link`, params);
  }

  reconnectLink(inboxId) {
    return window.axios.post(`${this.url}/connection/reconnect_link`, {
      inbox_id: inboxId,
    });
  }

  connect({ unipileAccountId, state }) {
    return window.axios.post(`${this.url}/connection`, {
      unipile_account_id: unipileAccountId,
      state,
    });
  }
}

export default new LinkedinApi();
